import { Injectable } from "@angular/core";
import { WarningModel } from "@lib/warning/models";

@Injectable({
    providedIn: 'root'
})
export class WarningService {
    sortWarnings(warning1: WarningModel, warning2: WarningModel) {
        return warning2.warning.levelId - warning1.warning.levelId;
      }
}